module.exports = __webpack_public_path__ + "static/media/twitter.34f20c90.png";